import { useDocumentEvent } from '@huse/document-event';
export function useClickOutside(ref, callback) {
  var testAndTrigger = function testAndTrigger(e) {
    var _a;

    if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
      callback(e);
    }
  };

  useDocumentEvent('mouseup', testAndTrigger, true);
  useDocumentEvent('touchstart', testAndTrigger, true);
}